import { type ReactNode } from 'react';
import cx from 'clsx';
import type { Attachment } from '../types';
import styles from '../responsive-view.module.css';

interface AttachmentsSectionProps {
  attachments: Attachment[];
  isAttachmentsLoaded: Record<string, boolean>;
  onAttachmentLoad: (attachmentId: string) => void;
}

export function AttachmentsSection({
  attachments,
  isAttachmentsLoaded,
  onAttachmentLoad,
}: AttachmentsSectionProps): ReactNode {
  return (
    <>
      {attachments.map((attachment, index) => {
        return attachment.src ? (
          <div className={cx(styles.pdfPreview, 'mb-48')} key={attachment.id}>
            <iframe
              className={cx(styles.iframe, !isAttachmentsLoaded[attachment.id] && styles.hidden)}
              data-test-attachment-pdf-preview
              data-testid="attachment-pdf-preview"
              onLoad={() => {
                onAttachmentLoad(attachment.id);
              }}
              src={`${attachment.src}#toolbar=0&view=Fit`}
              title={`Attachment PDF Preview ${index + 1}`.toString()}
            />
          </div>
        ) : null;
      })}
    </>
  );
}
